module.exports = __webpack_public_path__ + "img/020028.98824482.png";